export const LanguagesList: Map<number, string> = new Map()
  .set(1, 'nb')
  .set(2, 'en')
  .set(3, 'sv')
  .set(4, 'da')
  .set(5, 'pl')
  .set(6, 'de')
  .set(7, 'lt')
  .set(9, 'lv')
  .set(10, 'ru')
  .set(11, 'sr');
